import {
  includeHeaderFieldAndIndent,
} from '../utility';
import {
  DATA_TYPE_MONEY,
} from "typeConstants/dataTypes";

export default ({ coverageAIn, coverageAOut, coverageAEndorsed }, applyHeaderAndIndent) =>
  includeHeaderFieldAndIndent(applyHeaderAndIndent, "Coverage A",
    [
      { label: 'In', value: coverageAIn, dataType: DATA_TYPE_MONEY, dataTypeOptions: { numDigitsAfterDecimal: 0 }, editable: false },
      { label: 'Out', value: coverageAOut, dataType: DATA_TYPE_MONEY, dataTypeOptions: { numDigitsAfterDecimal: 0 }, editable: false },
      { label: 'Endorsed', value: coverageAEndorsed, dataType: DATA_TYPE_MONEY, editable: true },
    ],
  );